import { kpiDue, sinceLabel, ymd } from "../../lib/domain.js";

/* KPIs, each with a review date. A KPI past that date is flagged, and
   marking it reviewed stamps today rather than clearing the flag silently. */
export function KpiRows({ kpis, onChange, onReviewed, onNotify, mailEnabled }) {
  if (!kpis.length) return <p className="empty">No KPIs tracked yet.</p>;

  const set = (i, field, value) => {
    onChange(kpis.map((k, j) => (j === i ? { ...k, [field]: value } : k)));
  };

  return (
    <div className="rows">
      {kpis.map((k, i) => {
        const due = kpiDue(k);
        return (
          <div className={"kpi" + (due ? " due" : "")} key={i}>
            {/* A row of its own above the fields. The card's inputs are
                full width and wrap one to a line, so there is no row for
                this to sit at the end of — in the flow it landed between
                two inputs, and pinning it over them took width off every
                field below. */}
            <div className="delrow">
              <button
                className="btn-icon del"
                type="button"
                aria-label="Delete KPI"
                onClick={() => onChange(kpis.filter((_, j) => j !== i))}
              >
                &#10005;
              </button>
            </div>
            <input
              className="in grow"
              value={k.name}
              placeholder="KPI"
              aria-label={"KPI " + (i + 1) + " name"}
              onChange={(e) => set(i, "name", e.target.value)}
            />
            <div className="meta">
              <input
                className="in num fix-sm"
                value={k.value}
                placeholder="Now"
                aria-label="Current value"
                onChange={(e) => set(i, "value", e.target.value)}
              />
              <span className="of">of</span>
              <input
                className="in num fix-sm"
                value={k.target}
                placeholder="Target"
                aria-label="Target"
                onChange={(e) => set(i, "target", e.target.value)}
              />
              <input
                className="in fix-sm"
                value={k.unit}
                placeholder="Unit"
                aria-label="Unit"
                onChange={(e) => set(i, "unit", e.target.value)}
              />
              <input
                type="date"
                className="in dt"
                value={k.reviewOn}
                title="Up for review on"
                aria-label="Up for review on"
                onChange={(e) => set(i, "reviewOn", e.target.value)}
              />
              {due && <span className="pend bad">Review due</span>}
              {k.reviewOn && (
                <button className="btn btn-sm" type="button" onClick={() => onReviewed(i)}>
                  Mark reviewed
                </button>
              )}
              {k.lastReviewedAt && (
                <span className="wk sent">
                  reviewed {ymd(new Date(k.lastReviewedAt))}
                </span>
              )}
              {mailEnabled && (
                <button
                  className="btn btn-sm notify"
                  type="button"
                  onClick={() => onNotify(i)}
                >
                  Notify
                </button>
              )}
              {k.notifiedAt && <span className="wk sent">{sinceLabel(k.notifiedAt)}</span>}
            </div>
          </div>
        );
      })}
    </div>
  );
}
